import React from "react";

import { IconButton, IconButtonProps } from "@mui/material";

/**
 * An IconButton styled for the top bar: a consistent compact size and a
 * rounded-rectangle hover. Use this for EVERY top-bar icon button so the hover
 * target stays uniform as new icons are added. Icons inside should use
 * `fontSize="small"` to match.
 */
export const TopBarIconButton = React.forwardRef<
  HTMLButtonElement,
  IconButtonProps
>(({ sx, ...props }, ref) => (
  <IconButton
    ref={ref}
    size="small"
    {...props}
    sx={{ borderRadius: "8px", ...sx }}
  />
));

TopBarIconButton.displayName = "TopBarIconButton";
